<template>
  <div>
    <div class="full-width col">
      <div class="full-width q-pa-lg">
        <div class="full-width">
          <div v-html="title" class="text-h5 q-mb-lg"></div>
        </div>
        <div
          :class="`cf-turnstile-${tab}`"
          data-sitekey="0x4AAAAAABc14kBZhOpOtQ2W"
          data-size="flexible"
        ></div>
        <div class="full-width">
          <div class="bg-grey-2 full-width flex flex-center" style="min-height:110px;">
            <div class="">
              <q-btn
                color="primary"
                @click="google"
                unelevated
                class="q-pa-none"
                style="border:1px solid #1976d1"
                square
                id="auth-login-with-google"
              >
                <q-avatar color="white" square size="34px" >
                  <q-img src="/google-logo.png" width="30px"></q-img>
                </q-avatar>
                <div class="q-mx-md">
                  {{title}} with Google
                </div>
              </q-btn>
            </div>
          </div>
          <div class="text-center text-subtitle1 text-grey-5 q-my-sm">OR</div>
          <q-form @submit="submitForm">
            <div class="text-body1" v-if="tab === 'register'">Name</div>
            <q-input
              v-if="tab === 'register'"
              dense outlined
              class="q-mb-md"
              type="text"
              v-model="formData.name"
              for="auth-register-name"
            />

            <div class="text-body1">Email</div>
            <q-input
              outlined dense
              class="q-mb-md"
              type="email"
              v-model="formData.email"
              for="auth-email"
            />

            <div class="text-body1">Password</div>
            <q-input
              outlined
              dense
              class="q-mb-md"
              :type="passwordVisible ? 'text':'password'" v-model="formData.password"
              :autocomplete="tab === 'register' ? 'new-password' : 'current-password'"
              for="auth-password"
            >
              <template v-slot:append>
                <q-btn flat round
                  :icon="passwordVisible ? 'las la-eye-slash' : 'las la-eye'"
                  @click="passwordVisible = !passwordVisible"
                  id="auth-show-password"
                >
                  <q-tooltip>{{passwordVisible?'Hide':'Show'}} password</q-tooltip>
                </q-btn>
              </template>
            </q-input>
            <div class="row">
              <q-btn
                type="submit"
                color="primary"
                :label="title"
                no-caps
                unelevated
                id="auth-submit"
              />
              <q-space></q-space>
              <q-btn
                flat
                label="Forgot Password?"
                color="grey-7"
                class="q-px-none"
                no-caps
                v-if="tab !== 'register'"
                @click="forgotPassword"
                id="auth-forgot-password"
              />
            </div>
          </q-form>
        </div>
      </div>
    </div>

    <q-dialog v-model="resetPwdDialog">
      <ForgotPassword @done="resetPwdDialog=false"/>
    </q-dialog>
  </div>
</template>

<script>
import { useRouter } from 'vue-router'
import ForgotPassword from "./ForgotPassword.vue";
import { defineComponent, reactive, ref, computed, onMounted } from 'vue';
import {
  GoogleAuthProvider,
  getAuth,
  signInWithPopup,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword
} from 'firebase/auth'
import { getFirestore, doc, setDoc } from 'firebase/firestore'

import { useQuasar } from 'quasar';

const db = getFirestore()

export default defineComponent({
  name: 'AuthComponent',
  props: ['tab'],
  components: { ForgotPassword },
  setup (props, context) {
    const router = useRouter()
    const $q = useQuasar();
    const formData = reactive({
      name: '',
      email: '',
      password: ''
    });
    const title = computed(() => {
      return props.tab === 'login' ? 'Sign in' : 'Sign up';
    });
    const resetPwdDialog = ref(false);
    const passwordVisible = ref(false)
    const loading = ref(false)
    const submitForm = () => {
      if (props.tab === 'login') {
        signInExistingUser(formData.email, formData.password)
      } else {
        createUser(formData.email, formData.password, formData.name)
      }
    };
    function validateTurnstile() {
      const valid = window.turnstile &&
        window.turnstile.getResponse() &&
        !window.turnstile.isExpired()
      if (!valid) {
        $q.notify({
          message: 'Please verify that you are a human',
          type: 'warning',
          position: 'top',
          timeout: 2000,
        })
      }
      return valid
    }
    const google = () => {
      console.log('google login & signup')
      if (!validateTurnstile()) {
        return;
      }
      loading.value = true
      const provider = new GoogleAuthProvider();
      const auth = getAuth();
      signInWithPopup(auth, provider)
        .then(async result => {
          console.log('result', result)
          const user = result.user;
          const displayName = user.displayName;
          const email = user.email;
          await saveUser(user.uid, email, {name: displayName, emailVerified: user.emailVerified, photoURL: user.photoURL});
          await router.push('/');
        })
        .catch(error => console.log('error',error))
        .finally(() => {
          loading.value = false
        })
    };
    const signInExistingUser = (email, password) => {
      loading.value = true
      const auth = getAuth();
      if (!validateTurnstile()) {
        return;
      }
      signInWithEmailAndPassword(auth, email, password)
        .then((userCredential) => {
          // $q.notify({message: 'Sign in success'})
          router.push('/')
        })
        .catch(error => {
          console.log(error)
          let message = 'We couldn\'t log you in'
          if (error.code === 'auth/wrong-password' || error.code === 'auth/user-not-found') {
            message = 'Wrong email or password'
          }
          $q.notify({
            message,
            type: 'negative',
            position: 'top',
            timeout: 3000
          })
        })
        .finally(() => {
          loading.value = false
        })
    };
    const createUser = (email, password, name) => {
      console.log(email, password, name);
      loading.value = true
      const auth = getAuth();
      if (!validateTurnstile()) {
        return;
      }
      createUserWithEmailAndPassword(auth, email, password)
        .then(async userCredential => {
          await saveUser(userCredential.user.uid, email, {name, emailVerified: false})
          await router.push('/')
          // setDoc(doc(db, 'users', userCredential.user.uid), {
          //   name,
          //   email
          // })
          // .then(() => {
          //   router.push('/')
          // })
        })
        .catch(error => {
          console.log(error)
          let message = 'We couldn\'t sign you up'
          if (error.code === 'auth/email-already-in-use') {
            message = 'Email already in use. Please login.'
          }
          $q.notify({
            message,
            type: 'negative',
            position: 'top',
            timeout: 3000
          })
      })
        .finally(() => {
          loading.value = false
        })
    };
    async function saveUser(userId, email, {name, photoURL, emailVerified}) {
      await setDoc(doc(db, 'users', userId), {
        name,
        email
      })
      // no await, this is in the background. Notify "form-data new registration" form.
      void fetch('https://api.form-data.com/f/uxb1nu160kmtcykkl8xtho', {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'omit', // include, *same-origin, omit
        headers: {
          'Content-Type': 'application/json'
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: JSON.stringify({
          displayName: name,
          email,
          emailVerified,
          uid: userId,
          photoURL,
          version: 'v2'
        })
      })
    }
    const forgotPassword = () => {
      resetPwdDialog.value = true
    };
    const turnstileToken = ref(null)
    onMounted(() => {
      function renderTurnstile() {
        window.turnstile.render(`.cf-turnstile-${props.tab}`, {
          sitekey: "0x4AAAAAABc14kBZhOpOtQ2W",
          callback: function (token) {
            turnstileToken.value = token
            // console.log(`Challenge Success ${token}`);
          },
        });
      }
      if (window.turnstile) {
        renderTurnstile();
      } else {
        window.onloadTurnstileCallback = function () {
          renderTurnstile();
        };
      }
    })
    return {
      formData,
      resetPwdDialog,
      passwordVisible,
      submitForm,
      google,
      signInExistingUser,
      createUser,
      forgotPassword,
      title,
      loading
    }
  }
})
</script>
